export default "__VITE_ASSET__DZFi1nNQ__"